import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        this.$projets = this.$('projet')
        this.$images = this.$('image')
    }

    init() {
        this.$projets.forEach(($projet, i) => {
            $projet.addEventListener('mouseenter', () => {
                this.$images.forEach(($image, j) => {
                    if (i === j) {
                        $image.style.visibility = 'visible'
                    }
                })
            })

            $projet.addEventListener('mouseleave', () => {
                this.$images.forEach($image => {
                    $image.style.visibility = 'hidden'
                })
            })
        })
    }
}